import { useState, type ReactNode } from "react";
import { AppPortalContext } from "~/shared/lib/portal-context";

interface AppPortalProviderProps {
    className?: string;
    children: ReactNode;
}

export function AppPortalProvider({ className, children }: AppPortalProviderProps) {
    const [container, setContainer] = useState<HTMLDivElement | null>(null);
    return (
        <AppPortalContext.Provider value={container}>
            <div ref={setContainer} className={className}>
                {children}
            </div>
        </AppPortalContext.Provider>
    );
}
